// @flow

import React from "react";
import { Form, Grid, Card, Button, Icon } from "tabler-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import authActions from "../../redux/auth/action";
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import { validate } from "../../validate";
import clientService from "../../services/client";
import Buttonloader from "../../common/Loader/Buttonloader";
import { changeLanguage } from "../../../src/language/index";

const validationRules = [
  {
    field: "xValue",
    validations: ["required"],
    name: "Maximum Number Of Users / Agent",
  },
  {
    field: "sValue",
    validations: ["required"],
    name: "Sticky Agent Lifetime",
  },
  {
    field: "nValue",
    validations: ["required"],
    name: "Notification Alert Time",
  },
  {
    field: "qValue",
    validations: ["required"],
    name: "Queue Notification Message",
  },
  {
    field: "cmValue",
    validations: ["required"],
    name: "Connect Message",
  },
  {
    field: 'qValue_ml',
    validations: ['required'],
    name: 'Queue Notification Message'
  },
  {
    field: 'cmValue_ml',
    validations: ['required'],
    name: 'Connect Message'
  },
]

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        xValue: 0,
        sValue: 0,
        nValue: 0,
        qValue: '',
        cmValue: '',
        qValue_ml: '',
        cmValue_ml: ''
      },
      message: {
        style: "success",
        text: "",
      },
      isLoading: false,
      errors: {},
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNotification = this.handleNotification.bind(this);
    this.setLoadingToggle = this.setLoadingToggle.bind(this);
  }

  handleChange = (e, field) => {
    const { fields } = this.state,
      val = e.target.value;
    fields[field] = val;
    this.setState({ fields });
    //this.validate();
  };

  setLoadingToggle(value) {
    this.setState({ isLoading: value });
  }

  // validate
  validate() {
    const { fields } = this.state;
    const { isValid, errors } = validate(fields, validationRules);
    this.setState({ errors });
    return isValid;
  }

  //form submition
  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(this.validate());
    if (this.validate()) {
      this.setLoadingToggle(true);

      const data = {
        maxChatNumber: this.state.fields.xValue,
        timeForNotification: this.state.fields.nValue,
        stickyTime: this.state.fields.sValue,
        notificationText: this.state.fields.qValue,
        iniateChatText: this.state.fields.cmValue,
        notificationText_ml: this.state.fields.qValue_ml,
        iniateChatText_ml: this.state.fields.cmValue_ml,
      }
      clientService.settings(data)
        .then(response => {
          this.props.user.settingData.maxChatNumber = data.maxChatNumber;
          this.props.user.settingData.timeForNotification =
            data.timeForNotification;

          this.props.user.settingData.stickyTime = data.stickyTime;
          this.props.user.settingData.notificationText = data.notificationText;
          this.props.user.settingData.iniateChatText = data.iniateChatText;
          this.props.user.settingData.notificationText_ml = data.notificationText_ml;
          this.props.user.settingData.iniateChatText_ml = data.iniateChatText_ml;
          console.log(this.props.user)

          this.props.updateUserData(this.props.user);
          toast.success("Setting Changed successfully.");
          setTimeout(() => {
            this.props.history.push("/admin/dashboard");
          }, 3000);
        })
        .catch((error) => {
          this.setLoadingToggle(false);
          console.log(error);
          // this.setState(() => ({ message: { text: error.response.data.message, style: 'danger' } }));
          setTimeout(() => {
            this.handleNotification();
          }, 3000);
        });
    } else {
      console.log("eeeeeeee");
    }
  };

  componentDidMount() {
    document.title = "Voiceoc | Chat Settings";

    if (this.props.user != undefined) {
      const { fields } = this.state;
      fields['xValue'] = this.props.user.settingData.maxChatNumber;
      fields['nValue'] = this.props.user.settingData.timeForNotification
      fields['sValue'] = this.props.user.settingData.stickyTime
      fields['qValue'] = this.props.user.settingData.notificationText
      fields['cmValue'] = this.props.user.settingData.iniateChatText
      fields['qValue_ml'] = this.props.user.settingData.notificationText_ml
      fields['cmValue_ml'] = this.props.user.settingData.iniateChatText_ml
      this.setState({
        fields,
      });
      console.log(this.props);
    }
  }

  handleNotification() {
    this.setState(() => ({ message: { text: "", style: "" } }));
  }

  render() {
    const { message } = this.state;

    return (
      <SiteWrapperSuperAdmin>
        <Grid.Col lg={5} className="mx-auto ">
          <Card>
            <Card.Header>
              <Card.Title>
                {changeLanguage(this.props.siteLanguage, "inchat_setting")}
              </Card.Title>
            </Card.Header>
            <Card.Body>
              {!!message.text ? (
                <div className={"alert alert-" + message.style}>
                  <p>{message.text}</p>
                  <Icon
                    prefix="fa"
                    name="times"
                    onClick={this.handleNotification}
                  ></Icon>
                </div>
              ) : null}
              <form onSubmit={this.handleSubmit}>
                <Form.FieldSet>
                  <Form.Group
                    isRequired
                    label={changeLanguage(
                      this.props.siteLanguage,
                      "maximum_number_cust",
                    )}
                  >
                    <Form.Input
                      name="xValue"
                      type="text"
                      placeholder="x"
                      onChange={(e) => this.handleChange(e, "xValue")}
                      value={this.state.fields.xValue}
                    />
                    <label
                      style={{
                        display: this.state.errors.xValue ? "block" : "none",
                      }}
                      className="error"
                    >
                      {this.state.errors.xValue}
                    </label>
                  </Form.Group>

                  <Form.Group
                    isRequired
                    label={changeLanguage(
                      this.props.siteLanguage,
                      "sticky_agent",
                    )}
                  >
                    <Form.Input
                      name="sValue"
                      type="text"
                      placeholder={changeLanguage(
                        this.props.siteLanguage,
                        "sticky_agent",
                      )}
                      onChange={(e) => this.handleChange(e, "sValue")}
                      value={this.state.fields.sValue}
                    />
                    <label
                      style={{
                        display: this.state.errors.sValue ? "block" : "none",
                      }}
                      className="error"
                    >
                      {this.state.errors.sValue}
                    </label>
                  </Form.Group>

                  <Form.Group
                    isRequired
                    label={changeLanguage(
                      this.props.siteLanguage,
                      "wait_alert_time",
                    )}
                  >
                    <Form.Input
                      name="sValue"
                      type="text"
                      placeholder="n"
                      onChange={(e) => this.handleChange(e, "nValue")}
                      value={this.state.fields.nValue}
                    />
                    <label
                      style={{
                        display: this.state.errors.nValue ? "block" : "none",
                      }}
                      className="error"
                    >
                      {this.state.errors.nValue}
                    </label>
                  </Form.Group>

                  <Form.Group
                    isRequired
                    label={changeLanguage(
                      this.props.siteLanguage,
                      "queue_noti",
                    )}
                  >
                    <Form.Textarea
                      name="qValue"
                      type="text"
                      placeholder={changeLanguage(
                        this.props.siteLanguage,
                        "queue_noti",
                      )}
                      onChange={(e) => this.handleChange(e, "qValue")}
                      value={this.state.fields.qValue}
                    />
                    <label
                      style={{
                        display: this.state.errors.qValue ? "block" : "none",
                      }}
                      className="error"
                    >
                      {this.state.errors.qValue}
                    </label>
                  </Form.Group>
                  <Form.Group
                    isRequired
                    label= {changeLanguage(this.props.siteLanguage,'queue_noti_ml')}
                  >
                    
                    <Form.Textarea name="qValue_ml"
                      type="text"
                      placeholder={changeLanguage(this.props.siteLanguage,'queue_noti_ml')}
                      onChange={(e) => this.handleChange(e, 'qValue_ml')}
                      value={this.state.fields.qValue_ml} />
                    <label style={{ display: this.state.errors.qValue_ml ? 'block' : 'none' }} className="error">{this.state.errors.qValue_ml}</label>
                  </Form.Group>
                  <Form.Group
                    isRequired
                    label= {changeLanguage(this.props.siteLanguage,'queue_noti_ml')}
                  >
                    
                    <Form.Textarea name="qValue_ml"
                      type="text"
                      placeholder={changeLanguage(this.props.siteLanguage,'queue_noti_ml')}
                      onChange={(e) => this.handleChange(e, 'qValue_ml')}
                      value={this.state.fields.qValue_ml} />
                    <label style={{ display: this.state.errors.qValue_ml ? 'block' : 'none' }} className="error">{this.state.errors.qValue_ml}</label>
                  </Form.Group>

                  <Form.Group
                    isRequired
                    label={changeLanguage(
                      this.props.siteLanguage,
                      "connect_message",
                    )}
                  >
                    <Form.Textarea
                      name="cmValue"
                      type="text"
                      placeholder={changeLanguage(
                        this.props.siteLanguage,
                        "connect_message",
                      )}
                      onChange={(e) => this.handleChange(e, "cmValue")}
                      value={this.state.fields.cmValue}
                    />
                    <label
                      style={{
                        display: this.state.errors.cmValue ? "block" : "none",
                      }}
                      className="error"
                    >
                      {this.state.errors.cmValue}
                    </label>
                  </Form.Group>

                  <Form.Group
                    isRequired
                    label= {changeLanguage(this.props.siteLanguage,'connect_message_ml')}
                  >
                    <Form.Textarea name="cmValue_ml"
                      type="text"
                      placeholder={changeLanguage(this.props.siteLanguage,'connect_message_ml')}
                      onChange={(e) => this.handleChange(e, 'cmValue_ml')}
                      value={this.state.fields.cmValue_ml} />
                    <label style={{ display: this.state.errors.cmValue_ml ? 'block' : 'none' }} className="error">{this.state.errors.cmValue_ml}</label>
                  </Form.Group>

                </Form.FieldSet>

                {!this.state.isLoading ? (
                  <Button color="primary btn-block" type="submit">
                    {changeLanguage(this.props.siteLanguage, "change")}
                  </Button>
                ) : (
                  <Buttonloader loading={this.state.isLoading}></Buttonloader>
                )}
              </form>
            </Card.Body>
          </Card>
        </Grid.Col>
        <ToastContainer autoClose={5000} position={"bottom-right"} />
      </SiteWrapperSuperAdmin>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    siteLanguage: state.auth.siteLanguage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    updateUserData: (payload) => {
      dispatch(authActions.updateUserData(payload));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Settings),
);
